import { Command, HttpMethod } from "~/extensions/api";
export class FindPersonal extends Command {
    constructor() {
        super(HttpMethod.Get, "personal");
    }
}
